var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3029 0.931576C24.4007 0.800462 26.4695 1.52887 28.0283 2.95656C29.456 4.51537 30.1844 6.58406 30.0678 8.69646V22.3032C30.199 24.4156 29.456 26.4843 28.0428 28.0431C26.484 29.4708 24.4007 30.1992 22.3029 30.0681H8.69603C6.58362 30.1992 4.51491 29.4708 2.95609 28.0431C1.52839 26.4843 0.799973 24.4156 0.931088 22.3032V8.69646C0.799973 6.58406 1.52839 4.51537 2.95609 2.95656C4.51491 1.52887 6.58362 0.800462 8.69603 0.931576H22.3029ZM14.013 22.5658L23.8175 12.7322C24.7062 11.829 24.7062 10.3722 23.8175 9.48349L21.9236 7.58962C21.0204 6.68638 19.5635 6.68638 18.6603 7.58962L17.6842 8.58026C17.5385 8.72594 17.5385 8.9736 17.6842 9.11928C17.6842 9.11928 20.0006 11.4211 20.0443 11.4793C20.2046 11.6542 20.3065 11.8873 20.3065 12.1495C20.3065 12.6739 19.8841 13.111 19.345 13.111C19.0974 13.111 18.8643 13.009 18.704 12.8488L16.2711 10.4304C16.1545 10.3139 15.9506 10.3139 15.834 10.4304L8.88493 17.3795C8.40417 17.8602 8.12737 18.5012 8.1128 19.186L8.02539 22.6386C8.02539 22.828 8.08366 23.0028 8.21478 23.134C8.3459 23.2651 8.52072 23.3379 8.71011 23.3379H12.1337C12.833 23.3379 13.5031 23.0611 14.013 22.5658Z",
    fill: "#3b82f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicEdit);
export default __webpack_public_path__ + "static/media/ProfilePicEdit.b380f7c471c6d56d28b92f8ccb6d33ae.svg";
export { ForwardRef as ReactComponent };